import { render, staticRenderFns } from "./IndustryTrainingDetail.vue?vue&type=template&id=0a93e994&scoped=true&"
import script from "./IndustryTrainingDetail.vue?vue&type=script&lang=js&"
export * from "./IndustryTrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./IndustryTrainingDetail.vue?vue&type=style&index=0&id=0a93e994&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a93e994",
  null
  
)

export default component.exports